var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-6 w-full tile-bg-color rounded-lg shadow-lg",style:([_vm.customCss])},[_c('div',{staticClass:"course-tile-list-v2 rounded-lg"},[_c('div',{staticClass:"text-xl font-bold pt-6 pl-6 body-heading-color inter-font-regular"},[_vm._t("title")],2),_c('div',{staticClass:"p-6"},[_vm._t("courses-list")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }